import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=232aa150&scoped=true&"
import script from "./PropertyDetails.vue?vue&type=script&lang=js&"
export * from "./PropertyDetails.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&id=232aa150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232aa150",
  null
  
)

export default component.exports